import { TextInput } from "react-admin";

export function HiddenInput({ source, value }: { source: string; value: any }) {
  return <TextInput type="hidden" source={source} defaultValue={value} style={{ display: "none" }} />;
}
